import { render, staticRenderFns } from "./ReadSupplyView.vue?vue&type=template&id=2b8975c2&"
import script from "./ReadSupplyView.vue?vue&type=script&lang=js&"
export * from "./ReadSupplyView.vue?vue&type=script&lang=js&"
import style0 from "./ReadSupplyView.vue?vue&type=style&index=0&id=2b8975c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports